import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Flex,
  TextField,
} from '@backstage/ui';
import { FieldHint } from '../../../components/FieldHint';

interface TopicDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  initialName?: string;
  existingNames: string[];
  mode: 'create' | 'edit';
}

export const TopicDialog = ({
  open,
  onClose,
  onSave,
  initialName = '',
  existingNames,
  mode,
}: TopicDialogProps) => {
  const [name, setName] = useState(initialName);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(initialName);
    setError('');
  }, [initialName, open]);

  const validate = (value: string): string => {
    if (!value.trim()) {
      return 'Nome é obrigatório';
    }
    if (!/^[a-z0-9-]+$/.test(value)) {
      return 'Deve conter apenas letras minúsculas, números e hífens';
    }
    const otherNames =
      mode === 'edit'
        ? existingNames.filter(n => n !== initialName)
        : existingNames;
    if (otherNames.includes(value)) {
      return 'Já existe um tópico com esse nome';
    }
    return '';
  };

  const handleSave = () => {
    const validationError = validate(name);
    if (validationError) {
      setError(validationError);
      return;
    }
    onSave(name.trim());
    onClose();
  };

  return (
    <Dialog
      isOpen={open}
      isDismissable
      onOpenChange={nextOpen => {
        if (!nextOpen) onClose();
      }}
    >
      <DialogHeader>
        {mode === 'create' ? 'Novo Tópico' : 'Editar Tópico'}
      </DialogHeader>
      <DialogBody>
        <Flex direction="column">
          <TextField
            label="Nome do Tópico"
            size="medium"
            value={name}
            onChange={value => {
              setName(value);
              setError('');
            }}
          />
          <FieldHint error={!!error}>
            {error || 'Deve conter apenas letras minúsculas, números e hífens'}
          </FieldHint>
        </Flex>
      </DialogBody>
      <DialogFooter>
        <Button variant="primary" onPress={handleSave}>
          {mode === 'create' ? 'Criar' : 'Salvar'}
        </Button>
        <Button variant="secondary" slot="close" onPress={onClose}>
          Cancelar
        </Button>
      </DialogFooter>
    </Dialog>
  );
};
